import {GoogleMap, GoogleMapProps} from "@react-google-maps/api";
import React from "react";

import {isCI} from "../_common/_constants";

const GoogleMapWrapper = (props: GoogleMapProps): React.ReactElement =>
  isCI ? (
    <div className="w100p h100p bg-gray200" data-cy="google-maps" />
  ) : (
    <GoogleMap {...props} />
  );

export default GoogleMapWrapper;
